<div class="calendar-monthly-view">
  <div class="calendar-grid-wrapper flexBox">
    <div style="display: grid; gap: 10px; overflow-y: auto;" [ngStyle]="{'grid-template-columns': calendarGridColumns}">
      @for (calendar of data; track calendar) {
        <div class="calendar-grid">
          <div class="calendar-day-section" [style.height.px]="dayHeaderTitleHeight + dayHeaderTimeHeight">
            <div class="title-row">
              <div class="title-field" [style.height.px]="dayHeaderTitleHeight">{{ calendar.title }}</div>
            </div>
            <div class="day-of-week-row">
              @for (day of daysOfWeek; track day) {
                <div class="day-of-week" [style.height.px]="dayHeaderTimeHeight">{{ day }}</div>
              }
            </div>
          </div>
          <!-- Day Rows with Scrollable Container -->
          <div class="day-row-container">
            @for (week of calendar.calendarDays; track week) {
              <div class="day-row">
                @for (day of week; track day) {
                  <div
                    class="day-box"
              [ngClass]="{
                'day-past': day?.dayType === 'past', 
                'day-today': day?.dayType === 'today', 
                'day-future': day?.dayType === 'future'
              }"
                    >
                    @if (day) {
                      <div class="day-number">{{ day.day }}</div>
                    }
                    <div class="events">
                      @for (event of day.events; track event; let i = $index) {
                        <div
                          class="event"
                          [class.event-hidden]="i >= 3 && !day.isExpanded"
                          (click)="onEventClick(event)"
                          (mouseover)="onEventMouseOver(event, $event)"
                          (mouseleave)="onEventMouseLeave()"
                          >
                          <div class="event-item">
                            @switch (event?.eventType) {
                              <!-- All Day Event -->
                              @case (CalendarEventType.ALL_DAY) {
                                <span class="event-time">All Day</span>
                              }
                              <!-- Partial Single-Day Event -->
                              @case (CalendarEventType.PARTIAL_SINGLE) {
                                <span class="event-time">{{ event?.start | date: 'shortTime' }}</span>
                              }
                              <!-- Partial Multi-Day Event -->
                              @case (CalendarEventType.PARTIAL_MULTIPLE) {
                                <span class="event-time">{{ event?.start | date: 'shortTime' }}</span>
                              }
                              <!-- Default Case (Optional) -->
                              @default {
                                <span class="event-time">{{ event?.start | date: 'shortTime' }}</span>
                              }
                            }
                            <span class="event-subject">{{ event?.subject }}</span>
                          </div>
                        </div>
                      }
                      @if (day.events.length > 3) {
                        <button
                          class="more-events-button"
                          (click)="day.isExpanded = !(day.isExpanded)"
                          >
                          @if (!day.isExpanded) {
                            <span>▼</span>
                          }
                          @if (day.isExpanded) {
                            <span>▲</span>
                          }
                          {{ getButtonLabel(day) }}
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

  </div>
</div>
